import Annotation from "./annotation";
import { setLineStyle } from "../canvasUtils";
import { defaultTransform, defaultSize } from "../geometry";
export default class Magnifier extends Annotation {
  constructor() {
    super();

    this.showZoomedImage = false;
    this.x = 0;
    this.y = 0;

    this.imgX = 0;
    this.imgY = 0;

    this.color = "white";
    this.lineWidth = 1;
    this.defaultMagSize = 150;
    this.magnification = 2;

    this.saveCanvas = null;

    this.transform = defaultTransform();
    this.imgSize = defaultSize();
    this.viewSize = defaultSize();
    this.fit = defaultSize();
  }

  get imgOffsetW() { return Math.abs(this.viewSize.w - this.fit.w) / 2; }
  get imgOffsetH() { return Math.abs(this.viewSize.h - this.fit.h) / 2; }

  get offsetX() { return this.x + this.imgOffsetW; }
  get offsetY() { return this.y + this.imgOffsetH; }

  get minOffset() { return this.magnifierSize; }
  get maxOffsetX() { return this.fit.w - this.magnifierSize; }
  get maxOffsetY() { return this.fit.h - this.magnifierSize; }

  get minImg() { return this.magnifierSize / this.transform.zoom; }
  get maxImgX() { return this.imgSize.w - this.minImg; }
  get maxImgY() { return this.imgSize.h - this.minImg; }

  get zoomSize() { return this.magnifierSize * this.magnification * 2; }
  get maxZoomX() { return this.viewSize.w - this.zoomSize; }
  get maxZoomY() { return this.viewSize.h - this.zoomSize; }
  get zoomX() { return Math.min(this.offsetX, this.maxZoomX); }
  get zoomY() { return Math.min(this.offsetY, this.maxZoomY); }

  get magnifierSize() { return Math.min(this.defaultMagSize, this.imgSize.w / 2, this.imgSize.h / 2); }

  draw(ctx) {
    this.drawMagnifierBorder(ctx);

    if (this.showZoomedImage) {
      this.drawZoomedBorder(ctx);
      this.drawZoomedImage(ctx);
    }
  }

  drawMagnifierBorder(ctx) {
    let x = this.offsetX - this.magnifierSize;
    let y = this.offsetY - this.magnifierSize;
    let size = this.magnifierSize * 2;
    setLineStyle(ctx, this);
    ctx.beginPath();
    ctx.strokeRect(x, y, size, size);
    ctx.closePath();
  }

  drawZoomedBorder(ctx) {
    ctx.beginPath();
    ctx.strokeRect(this.zoomX, this.zoomY, this.zoomSize, this.zoomSize);
    ctx.closePath();
  }

  drawZoomedImage(ctx) {
    if (!this.saveCanvas) return;
    // x, y on top left corner of the zoomed in image
    let imgX = this.imgX - this.magnifierSize / this.transform.zoom;
    let imgY = this.imgY - this.magnifierSize / this.transform.zoom;
    // width within the image to zoom
    let size = this.zoomSize / (this.magnification * this.transform.zoom);
    ctx.drawImage(this.saveCanvas,
      imgX, imgY,
      size, size,
      this.zoomX, this.zoomY,
      this.zoomSize, this.zoomSize);
  }

  updatePosition(offsetX, offsetY, imgX, imgY) {
    this.x = Math.min(Math.max(offsetX, this.minOffset), this.maxOffsetX);
    this.y = Math.min(Math.max(offsetY, this.minOffset), this.maxOffsetY);
    this.imgX = Math.min(Math.max(imgX, this.minImg), this.maxImgX);
    this.imgY = Math.min(Math.max(imgY, this.minImg), this.maxImgY);
    this.signalReady();
  }

  mousedown() {
    this.showZoomedImage = true;
    this.signalReady();
  }

  mouseup() {
    this.showZoomedImage = false;
    this.signalReady();
  }
}